import { RoleID } from '@/lib/rbac'

type CapabilityWithRole = {
  idRole?: string | null
}

export const filterOutSiteRoles = <T extends CapabilityWithRole>(
  capabilities: readonly T[] = []
) => {
  return capabilities.filter(
    (capability) =>
      capability.idRole !== RoleID.SITE_ADMIN &&
      capability.idRole !== RoleID.SITE_DEVELOPER
  )
}

export const filterCapabilitiesWithRole = <T extends CapabilityWithRole>(
  capabilities: readonly T[] = []
) => {
  return capabilities.filter(
    (capability): capability is T & { idRole: string } =>
      Boolean(capability.idRole)
  )
}
